// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// // import { MobileNumberDropdown } from "../../components/MobileNumberDropdown";
// import {
//   TextField,
//   // InputAdornment,
//   MenuItem,
//   Box,
//   Typography,
// } from "@mui/material";
// import { Controller, useForm } from "react-hook-form";
// import { useDispatch } from "react-redux";
// import { api } from "../../api/api";
// import { useSelector } from "react-redux";
// import { Address_url, City_url, country_url, state_url } from "../../api/urls";
// import Loading from "../../components/Loading";
// import { setAddressData } from "../../Redux/AddressSlice";
// import { useLocation } from "react-router-dom";
// import { toast } from "react-toastify";

// import { InputAdornment } from "@mui/material";
// import { MobileNumberDropdown } from "../../components/MobileNumberDropdown"; 

// const AddressForm = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//    const [alphaTwoCode, setAlphaTwoCode] = useState("in");
//   const [selectedCountryCode, setSelectedCountryCode] = useState("");
//   const [alternateCountryCode, setAlternateCountryCode] = useState("");

//   // const [Regex] = useState(/^\d{10}$/); // 10-digit default
//   // const [primaryRegex] = useState(/^\d{10}$/);
//   // const [alternateRegex] = useState(/^\d{10}$/);
//   // const [primaryRegex] = useState(/^[6-9]\d{9}$/);
// const [alternateRegex] = useState(/^[6-9]\d{9}$/);

//   const [cities, setCities] = useState([]);
//   const [states, setStates] = useState([]);
//   const [countries, setCountries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
// const user = useSelector((state) => state.auth.user);
//   const editAddress = location.state?.editAddress;
//   const isEditMode = !!editAddress;

//   const {
//     control,
//     handleSubmit,
//     reset,
//     formState: { errors },
//     getValues,
//     //  trigger, 
//   } = useForm({
//     defaultValues: {},
//     mode:"onChange",


//   });
//   useEffect(() => {
//     if (user && !isEditMode) {
//       reset((prev) => ({
//         ...prev,
//         name: user.full_name || "",
//         email_iD: user.email || "",
//         primary_mobile: user.mobile_number || "",
//       }));
//     }
//   }, [user, isEditMode, reset]);
//   // Fetch dropdown data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [countriesRes, statesRes, citiesRes] = await Promise.all([
//           api.get(country_url),
//           api.get(state_url),
//           api.get(City_url),
//         ]);

//         setCountries(countriesRes.data);
//         setStates(statesRes.data);
//         setCities(citiesRes.data);
//       } catch (err) {
//         setError(err.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Reset form if in edit mode
//   useEffect(() => {
//     if (editAddress && countries.length && states.length && cities.length) {
//       const matchedCountry = countries.find(
//         (c) => c.id === editAddress.country_link
//       );

//       const matchedState = states.find((s) => s.id === editAddress.state_link);
//       const matchedCity = cities.find(
//         (c) => c.printable_name === editAddress.city
//       );


//       reset({
//         name: editAddress.name || "",
//         middleName: editAddress.middle_name || "",
//         address: editAddress.address || "",
//         address_two: editAddress.address_two || "",
//         landmark: editAddress.landmark || "",
//         pincode: editAddress.pincode || "",
//         country: matchedCountry?.name || "",
//         state: matchedState?.id || "",
//         city: matchedCity?.id || "",
//         email_iD: editAddress.email_iD || "",

//         primary_mobile: editAddress.primary_mobile?.startsWith("91")
//           ? editAddress.primary_mobile.slice(2)
//           : editAddress.primary_mobile?.startsWith("0")
//           ? editAddress.primary_mobile.slice(1)
//           : editAddress.primary_mobile || "",

//         alternate_mobile: editAddress.alternate_mobile?.startsWith("91")
//           ? editAddress.alternate_mobile.slice(2)
//           : editAddress.alternate_mobile?.startsWith("0")
//           ? editAddress.alternate_mobile.slice(1)
//           : editAddress.alternate_mobile || "",
//       });

//       setSelectedCountryCode(
//         editAddress.primary_mobile_country_code?.toString() || ""
//       );
//       setAlternateCountryCode(
//         editAddress.alternate_mobile_country_code?.toString() || ""
//       );
//     }
//   }, [editAddress, countries, states, cities, reset]);

//   // Submit logic
//   // const addAddress = async (newAddress) => {
//   //   try {
//   //     const response = await api.post(Address_url(""), newAddress);
//   //     if (response.status >= 200 && response.status < 300) {
//   //       dispatch(
//   //         setAddressData({
//   //           apiResponse: response.data,
//   //           formData: newAddress,
//   //         })
//   //       );

//   //       navigate(-1, {
//   //         state: {
//   //           formData: newAddress,
//   //           apiResponse: response.data,
//   //         },
//   //       });
//   //     }
//   //   } catch (error) {
//   //     if (error.response?.status === 400) {
//   //       console.log(error,"new error tp debug")
//   //       toast.error(error.response.data?.data || "Invalid input.");
//   //     } else {
//   //               console.log(error,"new error tp debug")
//   //       toast.error("Something went wrong. Please try again.");
//   //               console.log(error,"new error tp debug")
//   //     }
//   //   }
//   // };
//     const addAddress = async (newAddress) => {
//     try {
//       const response = await api.post(Address_url(""), newAddress);
//       if (response.status >= 200 && response.status < 300) {
//         dispatch(
//           setAddressData({
//             apiResponse: response.data,
//             formData: newAddress,
//           })
//         );

//         navigate(-1, {
//           state: {
//             formData: newAddress,
//             apiResponse: response.data,
//           },
//         });
//       }
//     } catch (error) {
//       if (error.response?.status === 400) {

//         toast.error(error.response.data?.data || "Invalid input.");
//       } else {

//         toast.error("Something went wrong. Please try again.");

//       }
//     }
//   };
//   const onSubmit = (data) => {
//     console.log(data,"i am getting submited")
//     const addressData = {
//       title: "Ms.",
//       name: data.name,
//       middle_name: data.middleName,
//       primary_mobile: "91" + data.primary_mobile,
//       primary_mobile_country_code: selectedCountryCode
//         ? Number(selectedCountryCode)
//         : 91,
//       address: data.address,
//       address_two: data.address_two,
//       landmark: data.landmark,
//       pincode: data.pincode,
//       email_iD: data.email_iD,
//       country_link: countries.find((c) => c.name === data.country)?.id,
//       state_link: data.state,
//       // name: cities.find((c) => c.id === data.city)?.printable_name, // pass city name
//       city: cities.find((c) => c.id === data.city)?.printable_name, // pass city name
//     };
//     if (data.alternate_mobile) {
//       addressData.alternate_mobile = +"91" + data.alternate_mobile;
//       addressData.alternate_mobile_country_code = alternateCountryCode || 91;
//     }

//     if (isEditMode) {
//       api
//         .put(Address_url(editAddress.id), addressData)
//         .then(() => navigate(-1))
//         .catch((err) => {
//           console.log("Update failed", err);
//           toast.error("Update failed");
//         });
//     } else {
//       addAddress(addressData);
//     }
//   };

//   if (loading) return <Loading />;
//   if (error) return <div>Error: {error}</div>;

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         p: 2,
//         bgcolor: "#f5f5f5",
//       }}
//     >
//       <Box
//         sx={{
//           backgroundColor: "#fff",
//           p: { xs: 2, md: 4 },
//           maxWidth: "900px",
//           width: "100%",
//           borderRadius: 2,
//         }}
//       >
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", md: "row" },
//               gap: 3,
//             }}
//           >
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography variant="h6" gutterBottom>
//                 Address Details rn
//               </Typography>

//               <Controller
//                 name="address"
//                 control={control}
//                 rules={{ required: "Address is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="House No/Flat No /Road No"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.address}
//                     helperText={errors.address?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="address_two"
//                 control={control}
//                 rules={{ required: "Area is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Area/Locality"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.address_two}
//                     helperText={errors.address_two?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="landmark"
//                 control={control}
//                 rules={{ required: "landmark is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Landmark"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.landmark}
//                     helperText={errors.landmark?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="country"
//                 control={control}
//                 rules={{ required: "Country is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Enter Country"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.country}
//                     helperText={errors.country?.message}
//                     value={field.value ?? ""}
//                   >
//                     {countries.map((country) => (
//                       <MenuItem key={country.id} value={country.name}>
//                         {country.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />

//               {/* <Controller
//                 name="state"
//                 control={control}
//                 rules={{ required: "State is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Enter State"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.state}
//                     helperText={errors.state?.message}
//                     value={field.value ?? ""}
//                      onChange={(e) => field.onChange(e.target.value)}
//                   >
//                     {states.map((state) => (
//                       <MenuItem key={state.id} value={state.name}>
//                         {state.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               /> */}
//               <Controller
//                 name="state"
//                 control={control}
//                 rules={{ required: "State is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Enter State"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.state}
//                     helperText={errors.state?.message}
//                     value={field.value ?? ""}
//                     onChange={(e) => field.onChange(e.target.value)}
//                   >
//                     {states.map((state) => (
//                       <MenuItem key={state.id} value={state.id}>
//                         {state.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />

//               <Controller
//                 name="city"
//                 control={control}
//                 rules={{ required: "City is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Select City"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.city}
//                     helperText={errors.city?.message}
//                     value={field.value ?? ""}
//                     onChange={(e) => field.onChange(e.target.value)}
//                   >
//                     {cities.map((city) => (
//                       <MenuItem key={city.id} value={city.id}>
//                         {city.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />

//               <Controller
//                 name="pincode"
//                 control={control}
//                 rules={{
//                   required: "Pincode is required",
//                   pattern: {
//                     value: /^[0-9]{6}$/,
//                     message: "Invalid pincode (must be 6 digits)",
//                   },
//                 }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Pincode"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.pincode}
//                     helperText={errors.pincode?.message}
//                   />
//                 )}
//               />
//             </Box>

//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography variant="h6" gutterBottom>
//                 Contact Details
//               </Typography>

//               <Controller
//                 name="name"
//                 control={control}
//                 rules={{ required: "Name is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Name"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.name}
//                     helperText={errors.name?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="middleName"
//                 control={control}
//                 rules={{ required: "Middlename is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Middle Name"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.middleName}
//                     helperText={errors.middleName?.message}
//                   />
//                 )}
//               />

//               {/* <Controller
//                 name="primary_mobile"
//                 control={control}
//                 rules={{
//                   required: "Phone number is required",
//                   pattern: {
//                     value: primaryRegex,
//                     message: "Invalid phone number",
//                   },
//                 }}
//                 render={({ field }) => (

//                   <TextField
//                     {...field}
//                     label="Phone Number"
//                     fullWidth
//                     margin="normal"
//                     type="tel"
//                     value={field.value?.replace(/^0+/, "") || ""}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/^0+/, ""); // strip leading 0s
//                       field.onChange(value);
//                     }}
//                     slotProps={{
//                       input: {

//                         onInput: (e) => {
//                           e.target.value = e.target.value.replace(
//                             /[^0-9]/g,
//                             ""
//                           ); // force only numbers
//                           field.onChange(e.target.value);
//                         },
//                       },
//                     }}
//                     error={!!errors.primary_mobile}
//                     helperText={errors.primary_mobile?.message}
//                   />
//                 )}
//               /> */}

// {/* <Controller
//   name="primary_mobile"
//   control={control}
//   rules={{
//     required: "Phone number is required",
//     pattern: {
//       value: /^[6-9]\d{9}$/,
//       message: "Invalid phone number",
//     },
//   }}
//   render={({ field }) => (
//     <TextField
//       {...field}
//       label="Phone Number"
//       fullWidth
//       margin="normal"
//       type="tel"
//       inputProps={{
//         inputMode: "numeric",
//         maxLength: 10,
//                     }}
//                     error={!!errors.primary_mobile}
//                     helperText={errors.primary_mobile?.message}
//                   />
//                 )}
//               /> */}
// <Controller
//   name="primary_mobile"
//   control={control}
//   rules={{
//     required: "Phone number is required",
//     pattern: {
//       value: /^[6-9]\d{9}$/,
//       message: "Invalid phone number",
//     },
//   }}
//   render={({ field }) => (
//     <TextField
//       {...field}
//       label="Phone Number"
//       fullWidth
//       margin="normal"
//       type="tel"
//       inputProps={{
//         inputMode: "numeric",
//         maxLength: 10,
//       }}
//       error={!!errors.primary_mobile}
//       helperText={errors.primary_mobile?.message}
//       InputProps={{
//         startAdornment: (
//           <Controller
//             name="country_code"
//             control={control}
//             defaultValue={selectedCountryCode} // from state
//             rules={{ required: "Country code is required" }}
//             render={({ field }) => (
//               <InputAdornment position="start">
//                 <MobileNumberDropdown
//                   countryData={countries} // your country array
//                   value={field.value}
//                   onChange={(v) => {
//                     field.onChange(v.country_mobile_code);
//                     setSelectedCountryCode(v.country_mobile_code);
//                     setAlphaTwoCode(v.alpha_two_code.toLowerCase());
//                   }}
//                 />
//               </InputAdornment>
//             )}
//           />
//         ),
//       }}
//       onChange={(e) => {
//         let val = e.target.value;
//         // remove leading 0 or country code
//         if (val.startsWith("0")) val = val.slice(1);
//         if (val.startsWith("91")) val = val.slice(2);
//         field.onChange(val);
//       }}
//     />
//   )}
// />
//               <Controller
//                 name="alternate_mobile"
//                 control={control}
//                 rules={{
//                   validate: (value) => {
//                     if (!value) return true; // optional field
//                     if (!alternateRegex.test(value))
//                       return "Invalid phone number";
//                     if (value === getValues("primary_mobile")) {
//                       return "Alternate number must be different ";
//                     }
//                     return true;
//                   },
//                 }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     type="tel"
//                     label="Alternate Number(optional)"
//                     fullWidth
//                     margin="normal"
//                     value={field.value?.replace(/^0+/, "") || ""}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/^0+/, ""); // strip leading 0s
//                       field.onChange(value);
//                     }}
//                     slotProps={{
//                       input: {
//                         inputMode: "numeric", // numeric keypad on mobile
//                         onInput: (e) => {
//                           e.target.value = e.target.value.replace(
//                             /[^0-9]/g,
//                             ""
//                           ); // block alphabets & symbols
//                           field.onChange(e.target.value);
//                         },
//                       },
//                     }}
//                     error={!!errors.alternate_mobile}
//                     helperText={errors.alternate_mobile?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="email_iD"
//                 control={control}
//                 rules={{
//                   required: "Email is required",
//                   pattern: {
//                     value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
//                     message: "Invalid email address",
//                   },
//                 }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Email"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.email_iD}
//                     helperText={errors.email_iD?.message}
//                   />
//                 )}
//               />
//             </Box>
//           </Box>

//           <Box sx={{ mt: 3, textAlign: "center" }}>
//             <button
//               type="submit"
//               style={{
//                 backgroundColor: "#000",
//                 color: "#fff",
//                 padding: "12px 24px",
//                 borderRadius: "4px",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: "1rem",
//                 width: "100%",
//                 maxWidth: "900px",
//                 "&:hover": {
//                   backgroundColor: "#333",
//                 },
//               }}
//             >
//               Save Address
//             </button>
//           </Box>
//         </form>
//       </Box>
//     </Box>
//   );
// };

// export default AddressForm;
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// // import { MobileNumberDropdown } from "../../components/MobileNumberDropdown";
// import {
//   TextField,
//   // InputAdornment,
//   MenuItem,
//   Box,
//   Typography,
// } from "@mui/material";
// import { Controller, useForm } from "react-hook-form";
// import { useDispatch } from "react-redux";
// import { api } from "../../api/api";
// import { useSelector } from "react-redux";
// import { Address_url, City_url, country_url, state_url } from "../../api/urls";
// import Loading from "../../components/Loading";
// import { setAddressData } from "../../Redux/AddressSlice";
// import { useLocation } from "react-router-dom";
// import { toast } from "react-toastify";

// import { InputAdornment } from "@mui/material";
// import { MobileNumberDropdown } from "../../components/MobileNumberDropdown"; 

// const AddressForm = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//    const [alphaTwoCode, setAlphaTwoCode] = useState("in");
//   const [selectedCountryCode, setSelectedCountryCode] = useState("");
//   const [alternateCountryCode, setAlternateCountryCode] = useState("");

//   // const [Regex] = useState(/^\d{10}$/); // 10-digit default
//   // const [primaryRegex] = useState(/^\d{10}$/);
//   // const [alternateRegex] = useState(/^\d{10}$/);
//   // const [primaryRegex] = useState(/^[6-9]\d{9}$/);
// const [alternateRegex] = useState(/^[6-9]\d{9}$/);

//   const [cities, setCities] = useState([]);
//   const [states, setStates] = useState([]);
//   const [countries, setCountries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
// const user = useSelector((state) => state.auth.user);
//   const editAddress = location.state?.editAddress;
//   const isEditMode = !!editAddress;

//   const {
//     control,
//     handleSubmit,
//     reset,
//     formState: { errors },
//     getValues,
//     //  trigger, 
//   } = useForm({
//     defaultValues: {},
//     mode:"onChange",


//   });
//   useEffect(() => {
//     if (user && !isEditMode) {
//       reset((prev) => ({
//         ...prev,
//         name: user.full_name || "",
//         email_iD: user.email || "",
//         primary_mobile: user.mobile_number || "",
//       }));
//     }
//   }, [user, isEditMode, reset]);
//   // Fetch dropdown data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [countriesRes, statesRes, citiesRes] = await Promise.all([
//           api.get(country_url),
//           api.get(state_url),
//           api.get(City_url),
//         ]);

//         setCountries(countriesRes.data);
//         setStates(statesRes.data);
//         setCities(citiesRes.data);
//       } catch (err) {
//         setError(err.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Reset form if in edit mode
//   useEffect(() => {
//     if (editAddress && countries.length && states.length && cities.length) {
//       const matchedCountry = countries.find(
//         (c) => c.id === editAddress.country_link
//       );

//       const matchedState = states.find((s) => s.id === editAddress.state_link);
//       const matchedCity = cities.find(
//         (c) => c.printable_name === editAddress.city
//       );


//       reset({
//         name: editAddress.name || "",
//         middleName: editAddress.middle_name || "",
//         address: editAddress.address || "",
//         address_two: editAddress.address_two || "",
//         landmark: editAddress.landmark || "",
//         pincode: editAddress.pincode || "",
//         country: matchedCountry?.name || "",
//         state: matchedState?.id || "",
//         city: matchedCity?.id || "",
//         email_iD: editAddress.email_iD || "",

//         primary_mobile: editAddress.primary_mobile?.startsWith("91")
//           ? editAddress.primary_mobile.slice(2)
//           : editAddress.primary_mobile?.startsWith("0")
//           ? editAddress.primary_mobile.slice(1)
//           : editAddress.primary_mobile || "",

//         alternate_mobile: editAddress.alternate_mobile?.startsWith("91")
//           ? editAddress.alternate_mobile.slice(2)
//           : editAddress.alternate_mobile?.startsWith("0")
//           ? editAddress.alternate_mobile.slice(1)
//           : editAddress.alternate_mobile || "",
//       });

//       setSelectedCountryCode(
//         editAddress.primary_mobile_country_code?.toString() || ""
//       );
//       setAlternateCountryCode(
//         editAddress.alternate_mobile_country_code?.toString() || ""
//       );
//     }
//   }, [editAddress, countries, states, cities, reset]);

//   // Submit logic
//   // const addAddress = async (newAddress) => {
//   //   try {
//   //     const response = await api.post(Address_url(""), newAddress);
//   //     if (response.status >= 200 && response.status < 300) {
//   //       dispatch(
//   //         setAddressData({
//   //           apiResponse: response.data,
//   //           formData: newAddress,
//   //         })
//   //       );

//   //       navigate(-1, {
//   //         state: {
//   //           formData: newAddress,
//   //           apiResponse: response.data,
//   //         },
//   //       });
//   //     }
//   //   } catch (error) {
//   //     if (error.response?.status === 400) {
//   //       console.log(error,"new error tp debug")
//   //       toast.error(error.response.data?.data || "Invalid input.");
//   //     } else {
//   //               console.log(error,"new error tp debug")
//   //       toast.error("Something went wrong. Please try again.");
//   //               console.log(error,"new error tp debug")
//   //     }
//   //   }
//   // };
//     const addAddress = async (newAddress) => {
//     try {
//       const response = await api.post(Address_url(""), newAddress);
//       if (response.status >= 200 && response.status < 300) {
//         dispatch(
//           setAddressData({
//             apiResponse: response.data,
//             formData: newAddress,
//           })
//         );

//         navigate(-1, {
//           state: {
//             formData: newAddress,
//             apiResponse: response.data,
//           },
//         });
//       }
//     } catch (error) {
//       if (error.response?.status === 400) {

//         toast.error(error.response.data?.data || "Invalid input.");
//       } else {

//         toast.error("Something went wrong. Please try again.");

//       }
//     }
//   };
//   const onSubmit = (data) => {
//     console.log(data,"i am getting submited")
//     const addressData = {
//       title: "Ms.",
//       name: data.name,
//       middle_name: data.middleName,
//       primary_mobile: "91" + data.primary_mobile,
//       primary_mobile_country_code: selectedCountryCode
//         ? Number(selectedCountryCode)
//         : 91,
//       address: data.address,
//       address_two: data.address_two,
//       landmark: data.landmark,
//       pincode: data.pincode,
//       email_iD: data.email_iD,
//       country_link: countries.find((c) => c.name === data.country)?.id,
//       state_link: data.state,
//       // name: cities.find((c) => c.id === data.city)?.printable_name, // pass city name
//       city: cities.find((c) => c.id === data.city)?.printable_name, // pass city name
//     };
//     if (data.alternate_mobile) {
//       addressData.alternate_mobile = +"91" + data.alternate_mobile;
//       addressData.alternate_mobile_country_code = alternateCountryCode || 91;
//     }

//     if (isEditMode) {
//       api
//         .put(Address_url(editAddress.id), addressData)
//         .then(() => navigate(-1))
//         .catch((err) => {
//           console.log("Update failed", err);
//           toast.error("Update failed");
//         });
//     } else {
//       addAddress(addressData);
//     }
//   };

//   if (loading) return <Loading />;
//   if (error) return <div>Error: {error}</div>;

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         p: 2,
//         bgcolor: "#f5f5f5",
//       }}
//     >
//       <Box
//         sx={{
//           backgroundColor: "#fff",
//           p: { xs: 2, md: 4 },
//           maxWidth: "900px",
//           width: "100%",
//           borderRadius: 2,
//         }}
//       >
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", md: "row" },
//               gap: 3,
//             }}
//           >
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography variant="h6" gutterBottom>
//                 Address Details rn
//               </Typography>

//               <Controller
//                 name="address"
//                 control={control}
//                 rules={{ required: "Address is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="House No/Flat No /Road No"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.address}
//                     helperText={errors.address?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="address_two"
//                 control={control}
//                 rules={{ required: "Area is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Area/Locality"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.address_two}
//                     helperText={errors.address_two?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="landmark"
//                 control={control}
//                 rules={{ required: "landmark is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Landmark"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.landmark}
//                     helperText={errors.landmark?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="country"
//                 control={control}
//                 rules={{ required: "Country is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Enter Country"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.country}
//                     helperText={errors.country?.message}
//                     value={field.value ?? ""}
//                   >
//                     {countries.map((country) => (
//                       <MenuItem key={country.id} value={country.name}>
//                         {country.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />

//               {/* <Controller
//                 name="state"
//                 control={control}
//                 rules={{ required: "State is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Enter State"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.state}
//                     helperText={errors.state?.message}
//                     value={field.value ?? ""}
//                      onChange={(e) => field.onChange(e.target.value)}
//                   >
//                     {states.map((state) => (
//                       <MenuItem key={state.id} value={state.name}>
//                         {state.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               /> */}
//               <Controller
//                 name="state"
//                 control={control}
//                 rules={{ required: "State is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Enter State"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.state}
//                     helperText={errors.state?.message}
//                     value={field.value ?? ""}
//                     onChange={(e) => field.onChange(e.target.value)}
//                   >
//                     {states.map((state) => (
//                       <MenuItem key={state.id} value={state.id}>
//                         {state.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />

//               <Controller
//                 name="city"
//                 control={control}
//                 rules={{ required: "City is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Select City"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.city}
//                     helperText={errors.city?.message}
//                     value={field.value ?? ""}
//                     onChange={(e) => field.onChange(e.target.value)}
//                   >
//                     {cities.map((city) => (
//                       <MenuItem key={city.id} value={city.id}>
//                         {city.printable_name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />

//               <Controller
//                 name="pincode"
//                 control={control}
//                 rules={{
//                   required: "Pincode is required",
//                   pattern: {
//                     value: /^[0-9]{6}$/,
//                     message: "Invalid pincode (must be 6 digits)",
//                   },
//                 }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Pincode"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.pincode}
//                     helperText={errors.pincode?.message}
//                   />
//                 )}
//               />
//             </Box>

//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography variant="h6" gutterBottom>
//                 Contact Details
//               </Typography>

//               <Controller
//                 name="name"
//                 control={control}
//                 rules={{ required: "Name is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Name"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.name}
//                     helperText={errors.name?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="middleName"
//                 control={control}
//                 rules={{ required: "Middlename is required" }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Middle Name"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.middleName}
//                     helperText={errors.middleName?.message}
//                   />
//                 )}
//               />


// <Controller
//   name="primary_mobile"
//   control={control}
//   rules={{
//     required: "Phone number is required",
//     pattern: {
//       value: /^[6-9]\d{9}$/,
//       message: "Invalid phone number",
//     },
//   }}
//   render={({ field }) => (
//     <TextField
//       {...field}
//       label="Phone Number"
//       fullWidth
//       margin="normal"
//       type="tel"
//       inputProps={{
//         inputMode: "numeric",
//         maxLength: 10,
//       }}
//       error={!!errors.primary_mobile}
//       helperText={errors.primary_mobile?.message}
//       InputProps={{
//         startAdornment: (
//           <Controller
//             name="country_code"
//             control={control}
//             defaultValue={selectedCountryCode} // from state
//             rules={{ required: "Country code is required" }}
//             render={({ field }) => (
//               <InputAdornment position="start">
//                 <MobileNumberDropdown
//                   countryData={countries} // your country array
//                   value={field.value}
//                   onChange={(v) => {
//                     field.onChange(v.country_mobile_code);
//                     setSelectedCountryCode(v.country_mobile_code);
//                     setAlphaTwoCode(v.alpha_two_code.toLowerCase());
//                   }}
//                 />
//               </InputAdornment>
//             )}
//           />
//         ),
//       }}
//       onChange={(e) => {
//         let val = e.target.value;
//         // remove leading 0 or country code
//         if (val.startsWith("0")) val = val.slice(1);
//         if (val.startsWith("91")) val = val.slice(2);
//         field.onChange(val);
//       }}
//     />
//   )}
// />
//               <Controller
//                 name="alternate_mobile"
//                 control={control}
//                 rules={{
//                   validate: (value) => {
//                     if (!value) return true; // optional field
//                     if (!alternateRegex.test(value))
//                       return "Invalid phone number";
//                     if (value === getValues("primary_mobile")) {
//                       return "Alternate number must be different ";
//                     }
//                     return true;
//                   },
//                 }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     type="tel"
//                     label="Alternate Number(optional)"
//                     fullWidth
//                     margin="normal"
//                     value={field.value?.replace(/^0+/, "") || ""}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/^0+/, ""); // strip leading 0s
//                       field.onChange(value);
//                     }}
//                     slotProps={{
//                       input: {
//                         inputMode: "numeric", // numeric keypad on mobile
//                         onInput: (e) => {
//                           e.target.value = e.target.value.replace(
//                             /[^0-9]/g,
//                             ""
//                           ); // block alphabets & symbols
//                           field.onChange(e.target.value);
//                         },
//                       },
//                     }}
//                     error={!!errors.alternate_mobile}
//                     helperText={errors.alternate_mobile?.message}
//                   />
//                 )}
//               />

//               <Controller
//                 name="email_iD"
//                 control={control}
//                 rules={{
//                   required: "Email is required",
//                   pattern: {
//                     value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
//                     message: "Invalid email address",
//                   },
//                 }}
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Email"
//                     fullWidth
//                     margin="normal"
//                     error={!!errors.email_iD}
//                     helperText={errors.email_iD?.message}
//                   />
//                 )}
//               />
//             </Box>
//           </Box>

//           <Box sx={{ mt: 3, textAlign: "center" }}>
//             <button
//               type="submit"
//               style={{
//                 backgroundColor: "#000",
//                 color: "#fff",
//                 padding: "12px 24px",
//                 borderRadius: "4px",
//                 border: "none",
//                 cursor: "pointer",
//                 fontSize: "1rem",
//                 width: "100%",
//                 maxWidth: "900px",
//                 "&:hover": {
//                   backgroundColor: "#333",
//                 },
//               }}
//             >
//               Save Address
//             </button>
//           </Box>
//         </form>
//       </Box>
//     </Box>
//   );
// };

// export default AddressForm;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  TextField,
  MenuItem,
  Box,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../api/api";
import { Address_url, City_url, country_url, state_url } from "../../api/urls";
import Loading from "../../components/Loading";
import { setAddressData } from "../../Redux/AddressSlice";
import { toast } from "react-toastify";
import { MobileNumberDropdown } from "../../components/MobileNumberDropdown";

const AddressForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  const editAddress = location.state?.editAddress;
  const isEditMode = !!editAddress;

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState("91");
  const [alternateCountryCode, setAlternateCountryCode] = useState("91");

  const alternateRegex = /^[6-9]\d{9}$/;

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
  });

  // Populate user data on new address
  useEffect(() => {
    if (user && !isEditMode) {
      reset({
        name: user.full_name || "",
        email_iD: user.email || "",
        primary_mobile: user.mobile_number || "",
      });
    }
  }, [user, isEditMode, reset]);

  // Fetch countries, states, cities
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [countriesRes, statesRes, citiesRes] = await Promise.all([
          api.get(country_url),
          api.get(state_url),
          api.get(City_url),
        ]);

        setCountries(countriesRes.data);
        setStates(statesRes.data);
        setCities(citiesRes.data);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Populate form if in edit mode
  useEffect(() => {
    if (editAddress && countries.length && states.length && cities.length) {
      const matchedCountry = countries.find(
        (c) => c.id === editAddress.country_link
      );
      const matchedState = states.find((s) => s.id === editAddress.state_link);
      const matchedCity = cities.find(
        (c) => c.printable_name === editAddress.city
      );

      reset({
        name: editAddress.name || "",
        middleName: editAddress.middle_name || "",
        address: editAddress.address || "",
        address_two: editAddress.address_two || "",
        landmark: editAddress.landmark || "",
        pincode: editAddress.pincode || "",
        country: matchedCountry?.name || "",
        state: matchedState?.id || "",
        city: matchedCity?.id || "",
        email_iD: editAddress.email_iD || "",
        primary_mobile: editAddress.primary_mobile
          ? editAddress.primary_mobile.replace(/^91|^0/, "")
          : "",
        alternate_mobile: editAddress.alternate_mobile
          ? editAddress.alternate_mobile.replace(/^91|^0/, "")
          : "",
      });

      setSelectedCountryCode(
        editAddress.primary_mobile_country_code?.toString() || "91"
      );
      setAlternateCountryCode(
        editAddress.alternate_mobile_country_code?.toString() || "91"
      );
    }
  }, [editAddress, countries, states, cities, reset]);

  // Submit logic
  const addAddress = async (newAddress) => {
    try {
      const response = await api.post(Address_url(""), newAddress);
      if (response.status >= 200 && response.status < 300) {
        dispatch(
          setAddressData({
            apiResponse: response.data,
            formData: newAddress,
          })
        );

        navigate(-1, {
          state: {
            formData: newAddress,
            apiResponse: response.data,
          },
        });
      }
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data?.data || "Invalid input.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };

  const onSubmit = (data) => {
    const addressData = {
      title: "Ms.",
      name: data.name,
      middle_name: data.middleName,
      primary_mobile: selectedCountryCode + data.primary_mobile,
      primary_mobile_country_code: Number(selectedCountryCode),
      address: data.address,
      address_two: data.address_two,
      landmark: data.landmark,
      pincode: data.pincode,
      email_iD: data.email_iD,
      country_link: countries.find((c) => c.name === data.country)?.id,
      state_link: data.state,
      city: cities.find((c) => c.id === data.city)?.printable_name,
    };

    if (data.alternate_mobile) {
      addressData.alternate_mobile =
        alternateCountryCode + data.alternate_mobile;
      addressData.alternate_mobile_country_code = Number(alternateCountryCode);
    }

    if (isEditMode) {
      api
        .put(Address_url(editAddress.id), addressData)
        .then(() => navigate(-1))
        .catch((err) => {
          // console.log("Update failed", err);
          toast.error("Update failed");
        });
    } else {
      addAddress(addressData);
    }
  };

  if (loading) return <Loading />;
  if (error) return <div>Error: {error}</div>;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        p: 2,
        bgcolor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          p: { xs: 2, md: 4 },
          maxWidth: "900px",
          width: "100%",
          borderRadius: 2,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 3,
            }}
          >
            {/* Left side - Address Details */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="h6" gutterBottom>
                Address Details
              </Typography>

              <Controller
                name="address"
                control={control}
                rules={{ required: "Address is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="House No/Flat No /Road No"
                    fullWidth
                    margin="normal"
                    error={!!errors.address}
                    helperText={errors.address?.message}
                  />
                )}
              />

              <Controller
                name="address_two"
                control={control}
                rules={{ required: "Area is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Area/Locality"
                    fullWidth
                    margin="normal"
                    error={!!errors.address_two}
                    helperText={errors.address_two?.message}
                  />
                )}
              />

              <Controller
                name="landmark"
                control={control}
                rules={{ required: "Landmark is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Landmark"
                    fullWidth
                    margin="normal"
                    error={!!errors.landmark}
                    helperText={errors.landmark?.message}
                  />
                )}
              />

              <Controller
                name="country"
                control={control}
                rules={{ required: "Country is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Select Country"
                    fullWidth
                    margin="normal"
                    error={!!errors.country}
                    helperText={errors.country?.message}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.id} value={country.name}>
                        {country.printable_name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />

              <Controller
                name="state"
                control={control}
                rules={{ required: "State is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Select State"
                    fullWidth
                    margin="normal"
                    error={!!errors.state}
                    helperText={errors.state?.message}
                  >
                    {states.map((state) => (
                      <MenuItem key={state.id} value={state.id}>
                        {state.printable_name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />

              <Controller
                name="city"
                control={control}
                rules={{ required: "City is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Select City"
                    fullWidth
                    margin="normal"
                    error={!!errors.city}
                    helperText={errors.city?.message}
                  >
                    {cities.map((city) => (
                      <MenuItem key={city.id} value={city.id}>
                        {city.printable_name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />

              <Controller
                name="pincode"
                control={control}
                rules={{
                  required: "Pincode is required",
                  pattern: {
                    value: /^[0-9]{6}$/,
                    message: "Invalid pincode (must be 6 digits)",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Pincode"
                    fullWidth
                    margin="normal"
                    error={!!errors.pincode}
                    helperText={errors.pincode?.message}
                  />
                )}
              />
            </Box>

            {/* Right side - Contact Details */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="h6" gutterBottom>
                Contact Details
              </Typography>

              <Controller
                name="name"
                control={control}
                rules={{ required: "Name is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Name"
                    fullWidth
                    margin="normal"
                    error={!!errors.name}
                    helperText={errors.name?.message}
                  />
                )}
              />

              <Controller
                name="middleName"
                control={control}
                rules={{ required: "Middle Name is required" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Middle Name"
                    fullWidth
                    margin="normal"
                    error={!!errors.middleName}
                    helperText={errors.middleName?.message}
                  />
                )}
              />

              {/* Primary Mobile */}
              <Controller
                name="primary_mobile"
                control={control}
                rules={{
                  required: "Phone number is required",
                  pattern: {
                    value: /^[6-9]\d{9}$/,
                    message: "Invalid phone number",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Phone Number"
                    fullWidth
                    margin="normal"
                    type="tel"
                    inputProps={{ inputMode: "numeric", maxLength: 10 }}
                    error={!!errors.primary_mobile}
                    helperText={errors.primary_mobile?.message}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MobileNumberDropdown
                            countryData={countries}
                            value={selectedCountryCode}
                            onChange={(v) => {
                              setSelectedCountryCode(v.country_mobile_code);
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => {
                      let val = e.target.value;
                      if (val.startsWith("0")) val = val.slice(1);
                      // if (val.startsWith("91")) val = val.slice(2);
                      field.onChange(val);
                    }}
                  />
                )}
              />

              {/* Alternate Mobile */}
              <Controller
                name="alternate_mobile"
                control={control}
                rules={{
                  validate: (value) => {
                    if (!value) return true;
                    if (!alternateRegex.test(value))
                      return "Invalid phone number";
                    if (value === getValues("primary_mobile"))
                      return "Alternate number must be different";
                    return true;
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="tel"
                    label="Alternate Number (optional)"
                    fullWidth
                    margin="normal"
                    value={field.value?.replace(/^0+/, "") || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/^0+/, "");
                      field.onChange(value);
                    }}
                    inputProps={{ inputMode: "numeric", maxLength: 10 }}
                    error={!!errors.alternate_mobile}
                    helperText={errors.alternate_mobile?.message}
                  />
                )}
              />

              {/* Email */}
              <Controller
                name="email_iD"
                control={control}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                    message: "Invalid email address",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Email"
                    fullWidth
                    margin="normal"
                    error={!!errors.email_iD}
                    helperText={errors.email_iD?.message}
                  />
                )}
              />
            </Box>
          </Box>

          <Box sx={{ mt: 3, textAlign: "center" }}>
            <button
              type="submit"
              style={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "12px 24px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                fontSize: "1rem",
                width: "100%",
                maxWidth: "900px",
              }}
            >
              Save Address
            </button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default AddressForm;
